import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { adminLogin } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await adminLogin(phone.trim(), password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="admin-login-page">
      <div className="text-center mb-8">
        <span className="inline-flex w-12 h-12 rounded-sm bg-navy-800 border border-gold/50 items-center justify-center"><ShieldCheck size={22} className="text-gold" /></span>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-100 mt-5">ADMIN ACCESS</h1>
        <p className="text-sm text-slate-500 mt-2">Restricted to authorized platform administrators.</p>
      </div>
      <form onSubmit={submit} className="card-surface hairline-gold p-7 space-y-5" data-testid="admin-login-form">
        <div>
          <label className="block text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2">Admin Phone</label>
          <input type="tel" required value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Registered admin number"
            data-testid="admin-phone-input" className="input-dark" />
        </div>
        <div>
          <label className="block text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••"
            data-testid="admin-password-input" className="input-dark" />
        </div>
        {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit-btn" className="btn-gold w-full disabled:opacity-60">
          {loading ? "VERIFYING…" : "ENTER COMMAND CENTER"}
        </button>
      </form>
    </div>
  );
}
